/* Akway reviews carousel autoplay (native Judge.me, ping-pong) */
(function () {
  var FLAG='akAutoInit';
  function fixImg(img){ var ds=img.getAttribute('data-src'); if(ds && (!img.getAttribute('src')||img.naturalWidth===0)) img.setAttribute('src',ds); img.removeAttribute('loading'); }
  function init(){
    var wrap=document.querySelector('.jdgm-carousel-wrapper');
    var track=wrap&&wrap.querySelector('.jdgm-carousel__item-wrapper');
    if(!wrap||!track) return false;
    if(track.dataset[FLAG]) return true;
    var items=track.querySelectorAll('.jdgm-carousel-item');
    if(items.length<2) return false;
    track.dataset[FLAG]='1';
    track.querySelectorAll('img').forEach(fixImg);
    /* ak-reflow: make Judge.me recompute card width for the wider container */
    [200,700,1500].forEach(function(ms){ setTimeout(function(){ window.dispatchEvent(new Event('resize')); }, ms); });
    var right=wrap.querySelector('.jdgm-carousel__right-arrow');
    var left=wrap.querySelector('.jdgm-carousel__left-arrow');
    if(right&&left){
      var dir=1,paused=false;
      wrap.addEventListener('mouseenter',function(){paused=true;});
      wrap.addEventListener('mouseleave',function(){paused=false;});
      var tf=function(){return getComputedStyle(track).transform;};
      setInterval(function(){
        if(paused)return;
        var before=tf();
        (dir===1?right:left).click();
        setTimeout(function(){ if(tf()===before){ dir*=-1; (dir===1?right:left).click(); } },650);
      },3500);
    }
    return true;
  }
  /* init() forces three full-page reflows and starts a 3.5s autoplay timer, so it must
     not run during LCP - the carousel sits far below the fold. */
  function start(wrap){
    if(!('IntersectionObserver' in window)){ init(); return; }
    var io=new IntersectionObserver(function(e){ if(e[0].isIntersecting){ io.disconnect(); init(); } },{rootMargin:'400px 0px'});
    io.observe(wrap);
  }
  function boot(){
    var wrap=document.querySelector('.jdgm-carousel-wrapper');
    if(wrap){ start(wrap); return; }
    var t=0,iv=setInterval(function(){
      wrap=document.querySelector('.jdgm-carousel-wrapper');
      if(wrap||++t>40){ clearInterval(iv); if(wrap) start(wrap); }
    },400);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
